// import React, { useState } from 'react';
import styled from 'styled-components/macro';
import { Link, useNavigate } from 'react-router-dom';

// import MultiChainSelect from '../../../UI/MultiChainSelect';
// import ReusableSelectBox from '../../../UI/ReusableSelectbox';
import { Button } from '../../../UI/Button';
import caretIconSrc from '../../../UI/icons/caret.svg';
import delegateIconSrc from './assets/delegate.svg';
import undelegateIconSrc from './assets/undelegate.svg';

const DelegationHeader = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  width: 100%;
  height: 56px;
  margin-bottom: 56px;

  position: relative;
`;

const ButtonBack = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;

  width: 56px;
  height: 56px;

  position: absolute;
  top: 0;
  left: 0;

  background-color: #ececf7;
  border-radius: 4px;
  border: none;

  transform: rotate(90deg);
`;

const Title = styled.div`
  font-size: 14px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 1.68px;
  color: ${props => props.theme.text2};
`;

const ArrowIcon = styled.div`
  width: 24px;
  height: 24px;
`;

const DelegationWrapper = styled.div`
  width: 480px;
  margin: 0 auto;
`;

const DelegationDetails = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: 100%;
  padding-bottom: 8px;

  border-bottom: 4px solid ${props => props.theme.bg4};

  color: ${props => props.theme.text2};
`;

const DelegationBalance = styled.div`
  margin-bottom: 8px;

  font-size: 12px;
  font-weight: 500;
`;

const DelegationAmountInput = styled.input`
  border: none;
  background-color: transparent;

  color: ${props => props.theme.text0};
  font-family: Bebas Neue, sans-serif;
  font-size: 28px;
  font-weight: bold;
`;

const DelegatePercent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  padding-top: 12px;

  font-size: 12px;
  font-weight: 500;
  color: #9895a6;
`;

// const ButtonsGroup = styled.div`
//   display: flex;
//   justify-content: space-between;
//   gap: 8px;
// `;
//
// const ButtonPercent = styled.button<{ active: boolean }>`
//   padding: 6px 12px;
//
//   background-color: ${props => (props.active ? '#0089e3' : '#fafaff')};
//   border: none;
//   border-radius: 4px;
//   box-shadow: 0 12px 26px 0 rgba(0, 0, 0, 0.06);
//
//   font-size: 12px;
//   font-weight: ${props => (props.active ? '600' : '500')};
//   color: ${props => (props.active ? '#fafaff' : '#9895a6')};
// `;

const BalanceDelegated = styled.div`
  display: flex;
  align-items: center;
`;

const BalanceDelegatedSum = styled.span`
  padding-left: 13px;

  color: ${props => props.theme.text1};
`;

// const SelectsWrapper = styled.div`
//   display: flex;
//   justify-content: center;
//   gap: 65px;
//
//   margin: 40px 0 0;
//   padding: 40px 0 135px;
//
//   border-top: 1px solid #e6e6f3;
// `;
//
// const SelectBoxTitle = styled.div`
//   padding-bottom: 12px;
//
//   font-size: 12px;
//   font-weight: 500;
//   color: ${props => props.theme.text2};
// `;
//
// const RetrievedValue = styled.div`
//   padding: 8px 16px;
//
//   border-radius: 4px;
//   box-shadow: 0 12px 26px 0 rgba(0, 0, 0, 0.06);
//   background-color: #ffffff;
//
//   font-size: 12px;
//   font-weight: 500;
//
//   user-select: none;
// `;

const ButtonDelegate = styled(Button)`
  width: 480px;
  height: 63px;
  margin: 20px auto 0;

  border-radius: 6px;
  box-shadow: 0 20px 36px 0 rgba(0, 0, 0, 0.1);
  background-color: #fbfbfd;

  font-size: 16px;
  font-weight: 500;
`;

const DelegateUndeleagteIcon = styled.div`
  position: absolute;
  left: 20px;
`;

// interface Asset {
//   imageSrc: string;
//   label: string;
//   value: string;
//   id: number;
// }
//
// interface AssetList {
//   option: string;
//   optionImageSrc: string;
//   id: number;
//   data: Asset[];
// }

// const Amount: AssetList[] = [
//   {
//     option: 'Ethereum',
//     optionImageSrc: 'https://www.cryptofonts.com/img/icons/eth.svg',
//     id: 1,
//     data: [
//       {
//         imageSrc: 'https://www.cryptofonts.com/img/icons/eth.svg',
//         label: 'Eth',
//         value: '20.4443 ETH',
//         id: 1,
//       },
//       {
//         imageSrc: 'https://www.cryptofonts.com/img/icons/usdc.svg',
//         label: 'Usd Coin',
//         value: '21.4423 ETH',
//         id: 2,
//       },
//       {
//         imageSrc: 'https://www.cryptofonts.com/img/icons/bnb.svg',
//         label: 'Binance',
//         value: '24.4423 ETH',
//         id: 3,
//       },
//     ],
//   },
//   {
//     option: 'Cosmos',
//     optionImageSrc: 'https://www.cryptofonts.com/img/icons/atom.svg',
//     id: 2,
//     data: [
//       {
//         imageSrc: 'https://www.cryptofonts.com/img/icons/shib.svg',
//         label: 'Shiba',
//         value: '28.1423 ETH',
//         id: 7,
//       },
//     ],
//   },
//   {
//     option: 'Polkadot',
//     optionImageSrc: 'https://www.cryptofonts.com/img/icons/dot.svg',
//     id: 3,
//     data: [
//       {
//         imageSrc: 'https://www.cryptofonts.com/img/icons/eth.svg',
//         label: 'Eth6',
//         value: '20.4443 ETH',
//         id: 1,
//       },
//       {
//         imageSrc: 'https://www.cryptofonts.com/img/icons/usdc.svg',
//         label: 'Usd Coin7',
//         value: '21.4423 ETH',
//         id: 2,
//       },
//       {
//         imageSrc: 'https://www.cryptofonts.com/img/icons/bnb.svg',
//         label: 'Binance',
//         value: '24.4423 ETH',
//         id: 3,
//       },
//     ],
//   },
// ];

// const displayOptions = [
//   {
//     key: '25',
//     label: '25%',
//   },
//   {
//     key: '50',
//     label: '50%',
//   },
//   {
//     key: '75',
//     label: '75%',
//   },
//   {
//     key: '100',
//     label: '100%',
//   },
// ];

// const gasFee = [
//   { value: '21 Standard', label: '21 Standard' },
//   { value: '22 Standard', label: '22 Standard' },
// ];
//
// const slippage = [
//   { value: 'No limit', label: 'No limit' },
//   { value: 'Limited', label: 'Limited' },
// ];
//
// const otransactionFee = { value: '$0.1 (0.0034 ETH)' };

type DelegationType = {
  type: 'delegate' | 'undelegate';
};

export default function Delegation({ type }: DelegationType) {
  // const [amount, setAmount] = useState('25');
  const navigate = useNavigate();

  return (
    <div>
      <DelegationHeader>
        <ButtonBack onClick={() => navigate(-1)}>
          <ArrowIcon>
            <img src={caretIconSrc} alt="" />
          </ArrowIcon>
        </ButtonBack>
        <Title>{type === 'delegate' ? 'Delegate' : 'UnDelegate'} Assets</Title>
      </DelegationHeader>
      <DelegationWrapper>
        <DelegationDetails>
          <div>
            <DelegationBalance>$2,092.34</DelegationBalance>
            <DelegationAmountInput type="text" value="2119.00" />
          </div>
          {/*<MultiChainSelect assetListOptions={Amount} large={false} /> */}
        </DelegationDetails>
        <DelegatePercent>
          {/* <ButtonsGroup>
            {displayOptions.map(button => (
              <ButtonPercent
                type="button"
                key={button.key}
                active={amount === button.key}
                onClick={() => setAmount(button.key)}
              >
                {button.label}
              </ButtonPercent>
            ))}
          </ButtonsGroup> */}
          <BalanceDelegated>
            Total
            <BalanceDelegatedSum>92,031.22 NOM</BalanceDelegatedSum>
          </BalanceDelegated>
          <BalanceDelegated>
            {/* {type === 'delegate' ? 'Balance' : 'Delegated'} */}
            Available
            <BalanceDelegatedSum>92,031.22 NOM</BalanceDelegatedSum>
          </BalanceDelegated>
        </DelegatePercent>
      </DelegationWrapper>
      {/*
      <SelectsWrapper>
        <div>
          <SelectBoxTitle>Gas Fee</SelectBoxTitle>
          <ReusableSelectBox options={gasFee} placeholder="" />
        </div>
        <div>
          <SelectBoxTitle>Slippage</SelectBoxTitle>
          <ReusableSelectBox options={slippage} placeholder="" />
        </div>
        <div>
          <SelectBoxTitle>Transaction Fee</SelectBoxTitle>
          <RetrievedValue>{otransactionFee.value}</RetrievedValue>
        </div>
      </SelectsWrapper>
      */}
      <Link to="../delegating" style={{ textDecoration: 'none' }}>
        <ButtonDelegate>
          <DelegateUndeleagteIcon>
            <img src={type === 'delegate' ? delegateIconSrc : undelegateIconSrc} alt="" />
          </DelegateUndeleagteIcon>
          {type === 'delegate' ? 'Delegate Assets' : 'Undelegate Assets'}
        </ButtonDelegate>
      </Link>
    </div>
  );
}
